import React from 'react';
import * as S from './TagSelect.styles';
import { Tag } from '@/typings/tag';
import Link from 'next/link';

type TagsSelect = {
  categories: Tag[];
  selectedCategory?: Tag;
  label?: string;
};

const TagsSelect: React.FC<TagsSelect> = ({ categories, selectedCategory, label }) => {
  return (
    <S.Wrapper>
      {label && <p>{label}</p>}
      <div>
        {categories.map((cat) => (
          <Link
            key={cat.id}
            href={`/prime-wine/${cat.slug}`}
            className={cat.id === selectedCategory?.id ? 'selected' : ''}
          >
            {cat.title}
          </Link>
        ))}
      </div>
    </S.Wrapper>
  );
};

export default TagsSelect;
